<template>
  <!-- <div class="login-dialog"> -->
  <div class="draw-Box">
    <div class="model-dialog model-lg" style="">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">登录</h4>
        </div>
        <div class="modal-body">
          <div class="row justify-content-center align-content-center login-center">
            <img class="mt-4 pt-1" width="185" style="display: block; margin: 50px auto" alt="" />
            <div class="text-center">
              <form class="mt-5" action="" method="post">
                <div class="input-group mb-3">
                  <input id="username" type="text" v-model="name" class="form-control" placeholder="账号" />
                </div>
                <div class="input-group mb-3">
                  <input type="password" class="form-control" v-model="password" placeholder="密码" />
                </div>
                <el-checkbox v-model="checked" style="margin-right: 300px;">2天自动登录</el-checkbox>
                <div><br></div>
                <span id="login-dialog" class="pull-left"> </span>
                <button type="button" class="btn btn-primary form-control mt-3 mb-5" @click="userLogin">
                  登录
                </button>
                <button type="button" class="btn btn-primary form-control mt-3 mb-5" @click="userLogout">
                  退出
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- </div> -->
</template>
<script>
  import {
    protocol_login,
    protocol_get_game_list,
    protocol_get_shop_game_list,
    shop_info,
    get_shop_data,
    ZgrGameShopget_game_shop
  } from "@/assets/js/network/request";
  import {
    gAccount
  } from "@/assets/js/data/Account";
  import {
    gGameData
  } from "@/assets/js/data/GameData";

  export default {
    name: "",
    data() {
      return {
        name: "", //登录时填写的用户
        password: "", //密码
        checked: false, //记住密码
      };
    },
    props: {
      title: String,
    },
    methods: {
      //登陆
      userLogin() {
        var _this = this;
        if (_this.name == "" || _this.password == "") {
          _this.$message({
            message: '请填写账号或者密码',
            type: 'warning'
          });
          return;
        }

        protocol_login(this.name, this.password).then((res) => {
          //protocol_login("test1","test1").then((res) => {
          gAccount.parseProtocal(res.ret);
          if (this.$data.checked) {
            this.$cookies.set("m_token_n", this.name, "2d");
            this.$cookies.set("m_token_p", this.password, "2d");
          }
          this.login_next();
        });
      },
      login_next() {
       protocol_get_game_list().then((res) => {
        gGameData.parseAllGameDataProtocal(res.ret);
          protocol_get_shop_game_list().then((res) => {
            gGameData.parseProtocal(res.ret);
            gGameData.parseProtocalShopData(res.ret);
            shop_info().then((res) => {
              gAccount.ser_Account_shopid(res.ret);
              get_shop_data().then((res) => {
                ZgrGameShopget_game_shop(gAccount.get_Account_shopid()).then((res1)=>{
                  let game_data=gGameData.getAllDataShopData();
                  for(var j = 0; j < game_data.length; j++){
                      game_data[j].price=0;
                  }
                  for(var i = 0; i < res1.ret.length; i++){
                    for(var j = 0; j < game_data.length; j++){
                      if(game_data[j].id==res1.ret[i].game_id){
                        game_data[j].price=res1.ret[i].price
                      }
                    }
                  }
                  gGameData.setAllDataShopDataPrice(game_data)
                  for (var i = 0; i < res.ret.length; i++) {
                    if (res.ret[i].id == gAccount.get_Account_shopid()) {
                      gAccount.ser_Account_shop(JSON.stringify(res.ret[i]));
                    }
                  }
                  this.$router.push({
                    path: "/Index"
                  });
                })
              })
            });
          });
        });
      },
      //登陆
      userLogout() {},
    },
    mounted() {
        console.log(1)
      if (this.$cookies.get("m_token_n") == null || this.$cookies.get("m_token_n") == 'null' || this.$cookies.get("m_token_p") == null|| this.$cookies.get("m_token_p") == 'null') {
        this.name = '';
        this.password = '';
        return;
      }else{
        this.name = this.$cookies.get("m_token_n");
        this.password = this.$cookies.get("m_token_p");
        this.userLogin();
      }


    },
  };
</script>
<style scoped>
  .login-dialog {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .draw-Box {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
  }

  .model-dialog {
    z-index: 2000;
    margin-top: 0px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -300px;
  }

  .modal-content {
    width: 600px;
    height: 511px;
    position: relative;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
  }

  .modal-header {
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 1rem;
    border-bottom: 1px solid #e9ecef;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }

  .modal-title {
    margin-bottom: 0;
    line-height: 1.5;
  }

  button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
  }

  .input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
  }

  .align-content-center {
    align-content: center !important;
  }

  .justify-content-center {
    justify-content: center !important;
  }

  .row {
    padding-left: 120px;
    padding-right: 120px;
  }

  .text-center {
    text-align: center !important;
  }

  .mt-5,
  .my-5 {
    margin-top: 3rem !important;
  }

  .mb-3,
  .my-3 {
    margin-bottom: 1rem !important;
  }

  .input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
  }

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }

  .input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
  }

  a:link,
  a:visited,
  a:hover {
    text-decoration: none;
  }

  .btn {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }

  .zhuce-mima {
    display: flex;
    justify-content: flex-end;
    color: #9d9d9d;
  }

  .zhuce-mima a:hover {
    color: #007aff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue